export default function () {
    const TypeAhead = require('type-ahead')


    function searchNav() {

        const getStartedButton = document.getElementById('get-started-link');
        const buttons = document.querySelectorAll('[data-search-toggle]');
        const closeButtons = document.querySelectorAll('[data-search-close]');
        const searchTexts = document.querySelectorAll('[data-search-text]');

        function setFormStyle() {
            const forms = document.querySelectorAll('.sxlarge-shrink form');
            for(const form of forms) {
                if (window.innerWidth >= 1800) {
                    form.style.width = (1800 - (getStartedButton.getBoundingClientRect().width + 0)) + 'px';
                } else {
                    form.style.width = 'calc(100vw - ' + (getStartedButton.getBoundingClientRect().width + 16) + 'px)';
                }
            }
        }

        for (const button of buttons) {
            button.addEventListener('click', function() {
                const parent = button.parentNode;
                const form = parent.querySelector('form');
                if (form.classList.contains('active')) {
                    form.classList.remove('active');
                } else {
                    setFormStyle();
                    form.classList.add('active');
                }
            });
        }

        for (const input of searchTexts) {

            input.addEventListener('ta:change', function() {
                const form = $(this).closest('form');
                form.submit();
            });
            const field = new TypeAhead(input);
            let xhr = null;
            field.getCandidates = function (callback) {
                if (xhr) {
                    xhr.abort();
                }
                xhr = $.getJSON(input.getAttribute('data-search-text') + '?query=' + this.query, function (response) {
                    callback(response);
                });
            };

            field.value = function (value) {

                this.selected = value;
                this.element.value = this.getItemValue(value);

                if (document.createEvent) {
                    var e = document.createEvent('HTMLEvents');
                    e.initEvent('ta:change', true, false);
                    this.element.dispatchEvent(e);
                } else {
                    this.element.fireEvent('ta:change');
                }
            };
        }


        for (const closeButton of closeButtons) {
            closeButton.addEventListener('click', function() {
                const form = closeButton.parentNode.parentNode;
                form.classList.remove('active');
            });
        }

        window.addEventListener('resize', function() {
            setFormStyle();
        });

    }

    searchNav();

}
